import { breakpoints, vars } from '@etg/wings';
import Loader from '../../components/Loader';
import { css } from '@eti/styles';

const ILLUSTRATION_ID = 'plane-globe';

const containerStyles = css`
  background-color: ${vars.colors.page.background.secondary};
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  padding-inline: 16px;

  @media (min-width: ${breakpoints._768}) {
    padding-inline: 24px;
  }
`;

interface LoadingAnimationProps {
  dataTestId?: string;
}

const LoadingAnimation = ({ dataTestId = 'loading-animation' }: LoadingAnimationProps) => (
  <div className={containerStyles}>
    <Loader dataTestId={dataTestId} illustrationId={ILLUSTRATION_ID} />
  </div>
);

export default LoadingAnimation;
